/*
This class addresses the issue of the 'vw' CSS unit type not properly reflecting the width of the scroll bar. The grid mixin relies on the 'vw' unit to work properly. With this fix constantly updating the '--grid-viewport-width' CSS variable to account for the scroll bar, we use the '--grid-viewport-width' variable (if it's available) in place of 'vw' in our grid script.
*/

module.exports = class ScrollbarGridWidthFix {

	constructor() {
		document.addEventListener('DOMContentLoaded', this.updateGridViewportWidth);
		window.addEventListener('resize', this.updateGridViewportWidth);
	}

	updateGridViewportWidth = () => {
		let width = '100vw';
		if (document.body) {
			const documentBodyElementWidth = document.body.offsetWidth;
			if (typeof documentBodyElementWidth === 'number') {
				width = documentBodyElementWidth.toString() + 'px';
			}
			document.body.style.setProperty('--grid-viewport-width', width);
		}
	}

};